import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vueEsign from 'vue-esign'
import '@/assets/font/fonts.css';

Vue.directive('debounce', {
  inserted(el, binding) {
    let timer = null
    el.addEventListener('click', () => {
      if (!timer) {
        binding.value()
        timer = setTimeout(() => {
          timer = null
        }, 3000)
      }
    })
  }
})

import Clipboard from 'clipboard'

// 注册全局指令
Vue.directive('clipboard', {
  bind(el, binding) {
    const clipboard = new Clipboard(el, {
      text: () => binding.value,
      action: () => binding.arg === 'cut' ? 'cut' : 'copy'
    })
    
    clipboard.on('success', e => {
      const callback = el._v_clipboard_success
      callback && callback(e)
      e.clearSelection()
    })
    
    clipboard.on('error', e => {
      const callback = el._v_clipboard_error
      callback && callback(e)
    })
    
    el._clipboard = clipboard
  }
})

import VueClipboard from 'vue-clipboard2'
 Vue.use(VueClipboard)



Vue.use(vueEsign)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
